import { useState } from "react";

const useStudentProfileMain = () => {
    const [showActivityModal, setShowActivityModal] = useState(false);

    const onActivityClick = () => {
        setShowActivityModal(true);
    }

    const onActivityCancelClick = () => {
        setShowActivityModal(false);
    }

    return {showActivityModal, onActivityClick, onActivityCancelClick}
}

export default useStudentProfileMain;